import { CardGradient } from "../components/CardGradient";

export default function Introduction({id}) {
  const description = `I'm Richard Roberson, a graduate student pursuing a Master's degree in Computer Science and Cloud Software Systems at the University of Colorado, Boulder, graduating in May 2026.
  In addition to my graduate studies, I completed my undergraduate degree in Computer Science at the University of Colorado, Boulder as well. 
  I bring professional experience from Ricoh, where I developed enterprise software solutions using modern technologies like Docker, Kubernetes, and cloud platforms. 
  Currently, I focus on AI and machine learning, specializing in LangChain, LangGraph, and AI-driven applications, 
  alongside research including a paper on text-to-SQL conversions. 
  I'm a driven learner, excited to take on new challenges, expand my skills, and contribute meaningfully to the field.`; 

  return (
    <div id={id}>
      <CardGradient title={'Hello, allow me to introduce myself...'} description={description} />
    </div>
  );
}